import TaxReportsActions from "@frameworks/web/redux/actions/Reports/CoreReports/taxReport";
export default () => {
    return {
        tax: new TaxReportsActions(),
    };
};
